/**
 * Копирует значения указанного столбца в буфер обмена.
 * Значения разделены переносом строки.
 */
export async function copyColumnToClipboard<T>(key: keyof T, data: T[]): Promise<void> {
  const values = data.map(row => String(row[key] ?? ''));
  const text = values.join('\n');
  await navigator.clipboard.writeText(text);
}
